<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>{{ action }} Structure List Entry</h3>
    </div>

    <div class="box">
      <div class="row">
        <coin-v2-text-input
          placeholder="TargetOrgCode"
          label="TargetOrgCode"
          [disabled]="action === Action.Edit || action === Action.Delete"
          [errorMessage]="validateString(item.TargetOrgCode)"
          [(ngModel)]="item.TargetOrgCode"></coin-v2-text-input>
      </div>
      <div class="row">
        <coin-v2-text-input
          placeholder="Position"
          label="Position"
          [disabled]="action === Action.Delete"
          [errorMessage]="validateString(item.Position)"
          [(ngModel)]="item.Position"></coin-v2-text-input>
      </div>

      <div class="row">
        <coin-v2-text-input
          placeholder="HeadGid"
          label="HeadGid"
          [disabled]="action === Action.Delete"
          [errorMessage]="validateString(item.HeadGid)"
          [(ngModel)]="item.HeadGid"></coin-v2-text-input>
      </div>

      <div class="row">
        <coin-dropdown
          placeholder="Acting"
          label="Acting"
          [items]="acting"
          [disabled]="action === Action.Delete"
          [(ngModel)]="item.Acting"></coin-dropdown>
      </div>

      <div class="buttons">
        <coin-v2-button
          [type]="'secondary'"
          [icon]="'close'"
          [iconPos]="'right'"
          [text]="'Cancel'"
          (click)="close()"></coin-v2-button>

        @if (action === Action.Edit) {
          <div>
            <coin-v2-button
              [type]="'primary'"
              [icon]="'upload'"
              [iconPos]="'right'"
              [text]="'Update'"
              [disabled]="uploading || !validate()"
              (click)="update()"></coin-v2-button>
          </div>
        }

        @if (action === Action.New) {
          <div #new>
            <coin-v2-button
              [type]="'primary'"
              [icon]="'upload'"
              [iconPos]="'right'"
              [text]="'Create'"
              [disabled]="uploading || !validate()"
              (click)="create()"></coin-v2-button>
          </div>
        }

        @if (action === Action.Delete) {
          <div #new>
            <coin-v2-button
              [type]="'primary'"
              [icon]="'delete'"
              [iconPos]="'right'"
              [text]="'Delete'"
              [disabled]="uploading || !validate()"
              (click)="delete()"></coin-v2-button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
